// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__xU-a5 {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  height: fit-content;
  padding: 0.5em 0;
  width: 98%;
  margin-left: 1%;
}
.styles_container__xU-a5 input {
  background-color: transparent;
  width: 100%;
  border: none;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  padding: 0 0.5em;
  background-color: transparent;
  width: 100%;
  border: none;
  border: 1px solid #eeeeee;
}
.styles_container__xU-a5 input:focus-visible {
  outline: 0;
}
.styles_container__xU-a5 input::placeholder {
  color: #bababa;
}

.styles_container__xU-a5 textarea {
  border-radius: 8px;
  min-height: 80px;
  padding: 10px;
  background-color: transparent !important;
}

.styles_container__xU-a5 textarea:focus,
.styles_container__xU-a5 textarea:active {
  outline: unset !important;
}

.styles_inputTitle__mQOJY {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}

.styles_inputError__Vk9BV {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_inputStyle__MX\\+op {
  width: 353px;
  height: 44px;
}

.styles_textareaStyle__ire7T {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #eeeeee;
  margin-bottom: 8px;
  resize: none;
  width: 100%;
}

.styles_wrapper__1kRqE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 353px;
  height: 44px;
}

.styles_prefix__TwYsD,
.styles_affix__7BiFT {
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_yellowBorder__i4o4N {
  border: 1px solid #ff9315;
}

.styles_inputStyle__MX\\+op::placeholder {
  color: #bababa;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}

.styles_inputStyle__MX\\+op:-moz-placeholder,
.styles_inputStyle__MX\\+op::-moz-placeholder,
.styles_inputStyle__MX\\+op:-ms-input-placeholder,
.styles_inputStyle__MX\\+op::-webkit-input-placeholder,
.styles_inputStyle__MX\\+op::placeholder {
  /* Modern browsers */
  color: #bababa;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}

@media screen and (max-width: 800px) {
  .styles_container__xU-a5 {
    height: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppFormTextArea/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AACF;AAEE;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EAGA,gBAAA;EAEA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAJJ;AAOE;EACE,UAAA;AALJ;AAQE;EACE,cAAA;AANJ;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;AAPF;;AAUA;;EAGE,yBAAA;AARF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AATF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAVF;;AAaA;EACE,YAAA;EACA,YAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EAEA,YAAA;EACA,WAAA;AAXF;;AAcA;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAZF;;AAeA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAZF;;AAeA;;;;;EASE,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAhBF;;AAmBA;EAEE;IACE,aAAA;EAjBF;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  height: fit-content;\n  padding: 0.5em 0;\n  width: 98%;\n  margin-left: 1%;\n\n\n  input {\n    background-color: transparent;\n    width: 100%;\n    border: none;\n    // background-color: #fafafa;\n    border-radius: 8px;\n    border: 1px solid #eeeeee;\n    // width: 353px;\n    // height: 44px;\n    padding: 0 0.5em;\n\n    background-color: transparent;\n    width: 100%;\n    border: none;\n    border: 1px solid #eeeeee;\n  }\n\n  input:focus-visible {\n    outline: 0;\n  }\n\n  input::placeholder {\n    color: #bababa;\n  }\n}\n\n.container textarea {\n  border-radius: 8px;\n  min-height: 80px;\n  padding: 10px;\n  background-color: transparent !important;\n}\n\n.container textarea:focus,\n.container textarea:active {\n  // border: unset !important;\n  outline: unset !important;\n}\n\n.inputTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  // color: #707070;\n  margin-bottom: 8px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 8px;\n\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.inputStyle {\n  width: 353px;\n  height: 44px;\n}\n\n.textareaStyle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  border: 1px solid #eeeeee;\n  margin-bottom: 8px;\n  // resize: horizontal;\n  resize: none;\n  width: 100%;\n}\n\n.wrapper {\n  // width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 353px;\n  height: 44px;\n}\n\n.prefix,\n.affix {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.yellowBorder {\n  border: 1px solid #ff9315;\n}\n\n.inputStyle::placeholder {\n  color: #bababa;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n}\n\n.inputStyle:-moz-placeholder,\n/* Firefox 18- */\n.inputStyle::-moz-placeholder,\n/* Firefox 19+ */\n.inputStyle:-ms-input-placeholder,\n/* IE 10+ */\n.inputStyle::-webkit-input-placeholder,\n/* Webkit based */\n.inputStyle::placeholder {\n  /* Modern browsers */\n  color: #bababa;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .container {\n    height: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__xU-a5`,
	"inputTitle": `styles_inputTitle__mQOJY`,
	"inputError": `styles_inputError__Vk9BV`,
	"inputStyle": `styles_inputStyle__MX+op`,
	"textareaStyle": `styles_textareaStyle__ire7T`,
	"wrapper": `styles_wrapper__1kRqE`,
	"prefix": `styles_prefix__TwYsD`,
	"affix": `styles_affix__7BiFT`,
	"yellowBorder": `styles_yellowBorder__i4o4N`
};
export default ___CSS_LOADER_EXPORT___;
